import React from 'react';
import { WhatsappShareButton, FacebookShareButton, WhatsappIcon, FacebookIcon } from 'react-share';

const ShareSlider = React.forwardRef (({ pptLink, excelLink }, ref) => {
  // console.log("PPT Link:", pptLink);
  // console.log("Excel Link:", excelLink);
  const getTheGreeting = () => {
    let currentHour = new Date().getHours();  // Get the current hour (0-23)
  
    if (currentHour >= 5 && currentHour < 12) {
      return "Good Morning";
    } else if (currentHour >= 12 && currentHour < 17) { 
      return "Good Afternoon";
    } else {
      return "Good Evening";
    }
  };

  const correctUrlForS3 = (url) => {
    return url?.replace(/ /g, "+");  // Replaces spaces with `+`
  };
  // The message to include in the share without breaking the URLs
  const message = `${getTheGreeting()} Sir, \n\nLink to Download Excel: ${correctUrlForS3(excelLink)}\n\Link to Download PPT: ${correctUrlForS3(pptLink)}\n\n`;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }} >
  {/* WhatsApp Share Button */}
  <WhatsappShareButton
    url={"https://www.yellowspot.in"}  // Use excelLink for WhatsApp
    title={message}
    ref={ref}
  >
    <WhatsappIcon size={32} round />
  </WhatsappShareButton>

  {/* Facebook Share Button */}
  {/* <FacebookShareButton
    url={"https://www.yellowspot.in"}  // Use excelLink for Facebook
    quote={message}  // Full message without splitting the URL
  >
    <FacebookIcon size={32} round style={{ padding: "10px" }} />
  </FacebookShareButton> */}
</div>

  );
});

export default ShareSlider;
